module.exports = __webpack_public_path__ + "img/bg-login.13322baf.jpg";